module.exports = __webpack_public_path__ + "assets/img/my-item-04.953baea1.png";